import React from "react";
import theme from "../../../Theme/Theme";
import styled, {createGlobalStyle} from "styled-components";
import Image from "./../../Atoms/Image";
import Skeleton from "react-loading-skeleton";
import PhaseIcon from '../../../Assets/Icons/phase.svg';

const GlobalStyle = createGlobalStyle`
  .react-tiny-popover-container {
    overflow: visible !important;
    pointer-events: none !important;
    z-index: 200;
  }
`;

const Wrapper = styled.div`
  box-shadow: rgba(8,11,14,0.06) 0px 0px 10px 4px, rgba(8,11,14,0.1) 0px 20px 40px 0px;
  padding: 2rem;
  background-color: white;
  // border: 1px solid ${props => props.color};
  
  width: 520px;
  min-height: 320px;
  
  @media (max-width: 1180px) {
    width: 300px;
    min-height: 250px;
  }
  @media (max-width: 915px) {
    width: 240px;
    min-height: 200px;
  }
  img {
    width: 100%;
  }
`;

const Title = styled.h3`
  color: #0A1F44;	
  font-family: Inter;	
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  margin: 0 0 1rem 0;
  
   &:before {
    content: "";
    width: 16px;
    height: 16px;
    border-radius: 100%;
    display: inline-block;
    background: ${props => props.color ? props.color :  `url(${ PhaseIcon })`};
    margin-right: 0.5rem;
   }
`;

function PopoverInner(props) {
  // let data = props.data.filter( d => d.name === props.hover )[0] ? props.data.filter( d => d.name === props.hover )[0] : {};
  let data = props.data;
  return (
    <Wrapper
      color={data.color ? data.color : undefined }
    >
      <GlobalStyle/>
      <Title color={data.color}>{ data.name }</Title>
      { data.field_image &&
        <Image
          image={data.field_image.data ? data.field_image.data : data.field_image }
        />
      }
      {
        data === {} &&
        <div style={{ display: 'block'}}>
          <Skeleton />
          <Skeleton
            height={'10rem'}
          />
        </div>
      }
    </Wrapper>
  )
}

export default PopoverInner;
